/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const PURCHASING_CATEGORIES: SupportCategory[] = [
  { id: 'purch-kitchen', label: 'Kitchen', departmentId: 'Purchasing' },
  { id: 'purch-food', label: 'Food', departmentId: 'Purchasing' },
  { id: 'purch-cleaning', label: 'Cleaning/ Disposables', departmentId: 'Purchasing' },
  { id: 'purch-office', label: 'Office / Classroom Supplies', departmentId: 'Purchasing' },
  { id: 'purch-furniture', label: 'Furniture, Fixtures, Equipment', departmentId: 'Purchasing' },
  { id: 'purch-toys', label: 'Toys', departmentId: 'Purchasing' },
];

export const PURCHASING_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'purch-kitchen-feedback', label: 'Feedback', categoryId: 'purch-kitchen' },
  { id: 'purch-kitchen-supplies', label: 'Kitchen Supplies', categoryId: 'purch-kitchen' },
  { id: 'purch-kitchen-provider', label: 'Provider Issues', categoryId: 'purch-kitchen' },
  { id: 'purch-kitchen-tinychef', label: 'Tinychef', categoryId: 'purch-kitchen' },
  { id: 'purch-food-special-events', label: 'Special Events', categoryId: 'purch-food' },
  { id: 'purch-food-staff-meal', label: 'Staff Meal', categoryId: 'purch-food' },
  { id: 'purch-cleaning', label: 'Cleaning/ Disposables', categoryId: 'purch-cleaning' },
  { id: 'purch-office', label: 'Office / Classroom Supplies', categoryId: 'purch-office' },
  { id: 'purch-furniture', label: 'Furniture, Fixtures, Equipment', categoryId: 'purch-furniture' },
  { id: 'purch-toys', label: 'Toys', categoryId: 'purch-toys' },
];

export const PURCHASING_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'purch-feedback-1',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-feedback-2',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'select',
    label: 'Which meal',
    required: true,
    options: [
      { value: 'Am snack', label: 'Am snack' },
      { value: 'Lunch', label: 'Lunch' },
      { value: 'PM snack', label: 'PM snack' },
      { value: 'Late pm snack', label: 'Late pm snack' },
    ],
  },
  {
    id: 'purch-feedback-3',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'text',
    label: 'Name of menu item',
    required: true,
  },
  {
    id: 'purch-feedback-4',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'select',
    label: 'Rate item: 1-5 (1 being bad, 5 being loved)',
    required: true,
    options: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
    ],
  },
  {
    id: 'purch-feedback-5',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'textarea',
    label: 'Feedback on Menu',
    required: true,
  },
  {
    id: 'purch-feedback-6',
    subcategoryId: 'purch-kitchen-feedback',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-supplies-1',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-supplies-2',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'textarea',
    label: 'What do you need?',
    required: true,
  },
  {
    id: 'purch-supplies-3',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'text',
    label: 'Quantity',
    required: true,
  },
  {
    id: 'purch-supplies-4',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'purch-supplies-5',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'text',
    label: 'Link of what is needed',
    required: false,
  },
  {
    id: 'purch-supplies-6',
    subcategoryId: 'purch-kitchen-supplies',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-provider-1',
    subcategoryId: 'purch-kitchen-provider',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-provider-2',
    subcategoryId: 'purch-kitchen-provider',
    type: 'select',
    label: 'Choose a provider',
    required: true,
    options: [
      { value: 'Sysco', label: 'Sysco' },
      { value: 'Gordons', label: 'Gordons' },
      { value: 'Primo', label: 'Primo' },
      { value: 'Cintas', label: 'Cintas' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'purch-provider-2-other',
    subcategoryId: 'purch-kitchen-provider',
    type: 'text',
    label: 'Specify provider',
    required: true,
    visibleWhen: { questionId: 'purch-provider-2', value: 'Other' },
  },
  {
    id: 'purch-provider-3',
    subcategoryId: 'purch-kitchen-provider',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'purch-provider-4',
    subcategoryId: 'purch-kitchen-provider',
    type: 'select',
    label: 'Was this resolved',
    required: true,
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    id: 'purch-provider-5',
    subcategoryId: 'purch-kitchen-provider',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-tinychef-1',
    subcategoryId: 'purch-kitchen-tinychef',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-tinychef-2',
    subcategoryId: 'purch-kitchen-tinychef',
    type: 'textarea',
    label: 'What do you need?',
    required: true,
  },
  {
    id: 'purch-tinychef-3',
    subcategoryId: 'purch-kitchen-tinychef',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'purch-tinychef-4',
    subcategoryId: 'purch-kitchen-tinychef',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-special-1',
    subcategoryId: 'purch-food-special-events',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-special-2',
    subcategoryId: 'purch-food-special-events',
    type: 'select',
    label: 'What Is this for',
    required: true,
    options: [
      { value: 'Curriculum', label: 'Curriculum' },
      { value: 'PBL', label: 'PBL' },
      { value: 'Spirit Team', label: 'Spirit Team' },
      { value: 'Special Meals', label: 'Special Meals' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'purch-special-2-other',
    subcategoryId: 'purch-food-special-events',
    type: 'text',
    label: 'Specify event',
    required: true,
    visibleWhen: { questionId: 'purch-special-2', value: 'Other' },
  },
  {
    id: 'purch-special-3',
    subcategoryId: 'purch-food-special-events',
    type: 'text',
    label: 'Name of event',
    required: true,
  },
  {
    id: 'purch-special-4',
    subcategoryId: 'purch-food-special-events',
    type: 'date',
    label: 'Date of event',
    required: true,
  },
  {
    id: 'purch-special-5',
    subcategoryId: 'purch-food-special-events',
    type: 'text',
    label: 'Time of event',
    required: true,
  },
  {
    id: 'purch-special-6',
    subcategoryId: 'purch-food-special-events',
    type: 'textarea',
    label: 'Provide a list of what is needed and amounts',
    required: true,
  },
  {
    id: 'purch-special-7',
    subcategoryId: 'purch-food-special-events',
    type: 'text',
    label: 'Food budget for event',
    required: true,
  },
  {
    id: 'purch-special-8',
    subcategoryId: 'purch-food-special-events',
    type: 'textarea',
    label: 'Anything else I need to know?',
    required: true,
  },
  {
    id: 'purch-special-9',
    subcategoryId: 'purch-food-special-events',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-staff-meal-1',
    subcategoryId: 'purch-food-staff-meal',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-staff-meal-2',
    subcategoryId: 'purch-food-staff-meal',
    type: 'select',
    label: 'What Is this for',
    required: true,
    options: [
      { value: 'Staff meeting', label: 'Staff meeting' },
      { value: 'Incentive', label: 'Incentive' },
      { value: 'Thank you', label: 'Thank you' },
      { value: 'Lunch & learn', label: 'Lunch & learn' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'purch-staff-meal-2-other',
    subcategoryId: 'purch-food-staff-meal',
    type: 'text',
    label: 'Specify meal',
    required: true,
    visibleWhen: { questionId: 'purch-staff-meal-2', value: 'Other' },
  },
  {
    id: 'purch-staff-meal-3',
    subcategoryId: 'purch-food-staff-meal',
    type: 'date',
    label: 'Date of meal',
    required: true,
  },
  {
    id: 'purch-staff-meal-4',
    subcategoryId: 'purch-food-staff-meal',
    type: 'text',
    label: 'Time of meal',
    required: true,
  },
  {
    id: 'purch-staff-meal-5',
    subcategoryId: 'purch-food-staff-meal',
    type: 'text',
    label: 'Number of staff',
    required: true,
  },
  {
    id: 'purch-staff-meal-6',
    subcategoryId: 'purch-food-staff-meal',
    type: 'textarea',
    label: 'Any Allergies',
    required: false,
  },
  {
    id: 'purch-staff-meal-7',
    subcategoryId: 'purch-food-staff-meal',
    type: 'text',
    label: 'Food budget',
    required: true,
  },
  {
    id: 'purch-staff-meal-8',
    subcategoryId: 'purch-food-staff-meal',
    type: 'textarea',
    label: 'Anything else I need to know',
    required: false,
  },
  {
    id: 'purch-staff-meal-9',
    subcategoryId: 'purch-food-staff-meal',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-cleaning-1',
    subcategoryId: 'purch-cleaning',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-cleaning-4',
    subcategoryId: 'purch-cleaning',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'purch-cleaning-2',
    subcategoryId: 'purch-cleaning',
    type: 'text',
    label: 'Quantity needed',
    required: true,
  },
  {
    id: 'purch-cleaning-3',
    subcategoryId: 'purch-cleaning',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'purch-cleaning-5',
    subcategoryId: 'purch-cleaning',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-office-1',
    subcategoryId: 'purch-office',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-office-4',
    subcategoryId: 'purch-office',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'purch-office-2',
    subcategoryId: 'purch-office',
    type: 'text',
    label: 'Quantity needed',
    required: true,
  },
  {
    id: 'purch-office-3',
    subcategoryId: 'purch-office',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },

  {
    id: 'purch-office-5',
    subcategoryId: 'purch-office',
    type: 'text',
    label: 'Link of what is needed (If this is from amazon, please put it in an amazon cart)',
    required: false,
  },
  {
    id: 'purch-office-6',
    subcategoryId: 'purch-office',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'purch-furniture-1',
    subcategoryId: 'purch-furniture',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-furniture-2',
    subcategoryId: 'purch-furniture',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'purch-furniture-3',
    subcategoryId: 'purch-furniture',
    type: 'text',
    label: 'Quantity needed',
    required: true,
  },
  {
    id: 'purch-furniture-4',
    subcategoryId: 'purch-furniture',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'purch-furniture-5',
    subcategoryId: 'purch-furniture',
    type: 'text',
    label: 'Link of what is needed (If this is from amazon, please put it in an amazon cart)',
    required: false,
  },
  {
    id: 'purch-furniture-6',
    subcategoryId: 'purch-furniture',
    type: 'file',
    label: 'Upload photos',
    required: false,
  },
  {
    id: 'purch-toys-1',
    subcategoryId: 'purch-toys',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'purch-toys-3',
    subcategoryId: 'purch-toys',
    type: 'text',
    label: 'Classroom',
    required: true,
  },
  {
    id: 'purch-toys-4',
    subcategoryId: 'purch-toys',
    type: 'text',
    label: 'Age Group',
    required: true,
  },
  {
    id: 'purch-toys-5',
    subcategoryId: 'purch-toys',
    type: 'text',
    label: 'Type of toys',
    required: true,
  },
  {
    id: 'purch-toys-2',
    subcategoryId: 'purch-toys',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'purch-toys-6',
    subcategoryId: 'purch-toys',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'purch-toys-7',
    subcategoryId: 'purch-toys',
    type: 'text',
    label: 'Links of what is needed',
    required: false,
  },
  {
    id: 'purch-toys-8',
    subcategoryId: 'purch-toys',
    type: 'file',
    label: 'Upload photos',
    required: false,
  },
];
